<template>
    <div class="article">
        <div class="header_top">
            <!-- <div class="left">
                <img src="/assets/img/images/more_all.png" alt="" />
            </div> -->
            <div class="center">
                <div class="title">{{ newsInfos.title }}</div>
                <div class="date">{{ newsInfos.relTime }}</div>
            </div>
            <!-- <div class="right">
                <div class="title">
                    <div class="bigTitle">公司要闻</div>
                    <div class="smallTitle">Company news</div>
                </div>
            </div> -->
        </div>
        <div class="widthrules">
            <div class="wenzhang">
                <div class="ql-container ql-snow">
                    <div class="ql-editor" style="width:890px;">
                        <div v-html="newsInfos.content"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { getGWInforNewsDetail } from '@/api/index';
export default {
    components: {},
    data() {
        return {
            languageType: '1',
            params: {},
            newsInfos: {}
        };
    },
    methods: {
        showParams() {
            this.params = JSON.parse(this.$route.query.params);
        },
        getGWInforNewsDetail() {
            let params = {
                language: this.languageType,
                detailId: this.params.id
            };
            getGWInforNewsDetail(params).then(res => {
                console.log('新闻资讯详情根据语言与ID阅读全文', res.obj);
                this.newsInfos = res.obj;
            });
        }
    },
    created() {
        this.showParams();
        if (sessionStorage.getItem('languageType')) {
            this.languageType = sessionStorage.getItem('languageType');
        }
        this.getGWInforNewsDetail();
        window.addEventListener('setItem', () => {
            this.languageType = sessionStorage.getItem('languageType');
            this.getGWInforNewsDetail();
        });
    }
};
</script>
<style scoped lang="less">
@deep: ~'>>>';
@import '/src/assets/css/article.less';
.ql-container.ql-snow {
    border: none;
}
</style>
